import customAxios from "./customAxios";

export const searchUsersForImpersonation = (baseUrl, query, page = 1) => {
  const path = `${baseUrl}/admin/impersonations/search`;

  return customAxios.get(path, { params: { q: query, page } })
    .then(({ data, status }) => ({
      response: data.data || [],
      meta: data.meta || {},
      status
    }))
    .catch(error => ({ error }));
};

export const startImpersonation = (baseUrl, targetUserId, reason) => {
  const path = `${baseUrl}/admin/impersonations`;

  return customAxios.post(path, { target_user_id: targetUserId, reason })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};

export const stopImpersonation = baseUrl => {
  const path = `${baseUrl}/admin/impersonations`;

  return customAxios.delete(path)
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => ({ error }));
};
